import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteTheme,
  fetchThemes,
} from '../../../store/landscapeAPI/theme/reducers/theme.slice';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import { ReportingDetailsThemesTemplate } from '../../templates';
import cn from 'classnames';
import styles from './ReportingDetailsThemesPage.module.css';

interface ReportingDetailsThemesPageProps {}

const ReportingDetailsThemesPage: FC<ReportingDetailsThemesPageProps> = () => {
  const { themes, status } = useSelector(
    (state: RootState) => state.themeSlice
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchThemes());
  }, [dispatch]);

  const handleDeleteTheme = (id: string) => {
    dispatch(deleteTheme(id));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <ReportingDetailsThemesTemplate
        data={themes ?? []}
        handleDeleteTheme={handleDeleteTheme}
      />
    </div>
  );
};

export default ReportingDetailsThemesPage;
